/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: [ 'production', 'staging' ],
    apiKey: process.env.MIX_BUGSNAG_API_KEY_JS,
    plugins: [new BugsnagPluginVue()],
})

import Dashboard from '@/Pages/Dashboard'
import Navbar from '@/Navbar'
import CustomerIndex from '@/Pages/Customer/CustomerIndex'
import Heading from '@/Components/Heading'
import CustomerCreadit from '@/Pages/Customer/CustomerCreadit'
import VueI18n from 'vue-i18n'
import BookingIndex from '@/Pages/Booking/BookingIndex'
import BookingCreadit from '@/Pages/Booking/BookingCreadit'
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone'
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'
import ChangePassword from '@/Pages/User/ChangePassword'
import RequiredIcon from '@/Components/RequiredIcon'
import ServicesCreadit from '@/Pages/Services/ServicesCreadit'
import BookingShow from '@/Pages/Booking/BookingShow'
import VueCurrencyInput from 'vue-currency-input'
import CitySurchargeCreadit from '@/Pages/CitySurcharge/CitySurchargeCreadit'
import AdminUserIndex from '@/Pages/AdminUser/AdminUserIndex'
import AdminUserCreadit from '@/Pages/AdminUser/AdminUserCreadit'
import PickupIndex from '@/Pages/Pickup/PickupIndex'
import CurrenciesCreadit from '@/Pages/Currency/CurrenciesCreadit'
import DraftIndex from '@/Pages/Draft/DraftIndex'
import UserCreadit from '@/Pages/User/UserCreadit'
import CompanyEdit from '@/Pages/Company/CompanyEdit'
import PickupCreate from '@/Pages/Pickup/PickupCreate'
import SavedRecipientIndex from '@/Pages/SavedData/Recipient/SavedRecipientIndex'
import SavedRecipientCreadit from '@/Pages/SavedData/Recipient/SavedRecipientCreadit'
import SavedLoadingAddressIndex from '@/Pages/SavedData/LoadingAddress/SavedLoadingAddressIndex'
import SavedLoadingAddressCreadit from '@/Pages/SavedData/LoadingAddress/SavedLoadingAddressCreadit'
import SavedUnloadingAddressIndex from '@/Pages/SavedData/UnloadingAddress/SavedUnloadingAddressIndex'
import SavedUnloadingAddressCreadit from '@/Pages/SavedData/UnloadingAddress/SavedUnloadingAddressCreadit'
import SavedSenderIndex from '@/Pages/SavedData/Sender/SavedSenderIndex'
import SavedSenderCreadit from '@/Pages/SavedData/Sender/SavedSenderCreadit'
import SavedPickupAddressCreadit from '@/Pages/SavedData/PickupAddress/SavedPickupAddressCreadit'
import SavedPickupAddressIndex from '@/Pages/SavedData/PickupAddress/SavedPickupAddressIndex'
import TerminalsIndex from '@/Pages/Setting/Terminals/TerminalsIndex'
import TerminalsCreadit from '@/Pages/Setting/Terminals/TerminalsCreadit.vue'

require('./bootstrap')

window.Vue = require('vue')
Bugsnag.getPlugin('vue')
    .installVueErrorHandler(Vue)
window.moment = moment
moment.locale('da')

Vue.prototype.$moment = moment;

const pluginOptions = {
    /* see config reference */
    globalOptions: { currency: 'USD' },
}
Vue.use(VueCurrencyInput, pluginOptions)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const lang = document.documentElement.lang.substr(0, 2)

window.i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'da',
    messages: window.vuei18nLocales,
})

Vue.component('heading', Heading)
Vue.component('multiselect', Multiselect)
Vue.component('b-nav-item-dropdown', BNavItemDropdown)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('required-icon', RequiredIcon)

Vue.prototype.$saveSuccess = function () {
    // Get the snackbar DIV
    var x = document.getElementById('toast')

    // Add the "show" class to DIV
    x.className = x.className + ' show'

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () { x.className = x.className.replace('show', '') }, 3000)
}

Vue.prototype.$saveError = function (text) {
    // Get the snackbar DIV
    var x = document.getElementById('toast-error')
    x.innerText = "";
    x.innerText = text;
    // Add the "show" class to DIV
    x.className = x.className + ' show'

    // After 5 seconds, remove the show class from DIV
    setTimeout(function () { x.className = x.className.replace('show', '') }, 5000)
}

const app = new Vue({
    el: '#app',
    i18n,
    data: {
        isAdmin: false,
        isSuperAdmin: false,
        language: "da",
        userId: null,
        username: null,
        companyId: null
    },
    components: {
        Dashboard,
        Navbar,
        CustomerIndex,
        CustomerCreadit,
        BookingIndex,
        BookingCreadit,
        BookingShow,
        ChangePassword,
        ServicesCreadit,
        CitySurchargeCreadit,
        AdminUserIndex,
        AdminUserCreadit,
        PickupIndex,
        CurrenciesCreadit,
        DraftIndex,
        UserCreadit,
        CompanyEdit,
        PickupCreate,
        SavedRecipientIndex,
        SavedRecipientCreadit,
        SavedLoadingAddressIndex,
        SavedLoadingAddressCreadit,
        SavedUnloadingAddressCreadit,
        SavedUnloadingAddressIndex,
        SavedSenderIndex,
        SavedSenderCreadit,
        SavedPickupAddressIndex,
        SavedPickupAddressCreadit,
        TerminalsIndex,
        TerminalsCreadit
    },
    mounted () {
        if (window.lgt) {
            this.isAdmin = lgt.isAdmin
            this.isSuperAdmin = lgt.isSuperAdmin
            this.language = lgt.language
            this.userId = lgt.userId
            this.companyId = lgt.companyId
            this.username = lgt.loggedInUsername
        }
        var urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('success')) {
            this.$saveSuccess()
            window.history.replaceState({}, document.title, document.location.origin + document.location.pathname)
        }
    },
})
